import { render, staticRenderFns } from "./CreateNewHubModal.vue?vue&type=template&id=aff99390"
import script from "./CreateNewHubModal.vue?vue&type=script&lang=js"
export * from "./CreateNewHubModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports